import { styled as muiStyled, Stack } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const ReportButton = muiStyled(Stack)<{ disabled: boolean }>(
  ({ disabled }) => ({
    border: `1px solid ${NEW_COLORS.GRAYSCALE[200]}`,
    padding: '20px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '100%',
    borderRadius: '8px',
    flexDirection: 'row',
    minHeight: '32px',
    opacity: disabled ? 0.6 : 1,
    cursor: disabled ? 'default' : 'auto',
    '&:hover': {
      backgroundColor: NEW_COLORS.GRAYSCALE[100],
    },
    '&:disabled': {
      backgroundColor: NEW_COLORS.GRAYSCALE[100],
      borderColor: NEW_COLORS.GRAYSCALE[200],
    },
  }),
);
